import style from "./CSS/RoundVideoResult.module.css";
import Round from "./Component/Round";
import Title from "./Component/Title";
import SubTitle from "./Component/SubTitle";
import Details from "./Component/Details";
import profileImage from "./img/profile.png";
import videoImage from "./img/video.png";
import Banner from "./Component/Banner";
import coverPhoto from "./img/banner.png";

const data = [
  { video: videoImage, markA: 54, markB: 52, markC: 54, status: "yes" },
  { video: videoImage, markA: 34, markB: 84, markC: 24, status: "no" },
  { video: videoImage, markA: 35, markB: 45, markC: 34, status: "yes" },
  { video: videoImage, markA: 78, markB: 45, markC: 64, status: "no" },
  { video: videoImage, markA: 75, markB: 65, markC: 75, status: "yes" },
  { video: videoImage, markA: 25, markB: 75, markC: 45, status: "yes" },
];

const RoundVideoResult = () => {
  return (
    <>
      <div className={style.audition__round__summary}>
        <Round round={"01"} status={"running"} />
        <Round round={"02"} status={"pending"} />
        <Round round={"03"} status={"pending"} />
        <Round round={"04"} status={"pending"} />
        <Round round={"05"} status={"pending"} />
        <Round round={"06"} status={"pending"} />
      </div>

      <div>
        <Title title={"round status"} />
      </div>

      <div>
        <SubTitle subTitle={"submitted content"} />
      </div>

      <div>
        <Banner
          title={"1st round time duration june 25 - july 30"}
          coverPhoto={coverPhoto}
        />
      </div>

      <div>
        <Title title={"audition round-1"} />
      </div>

      <div>
        <SubTitle subTitle={"total video - 9"} />
      </div>

      <div>
        <Title title={"round 1 - jury result (group c)"} />
      </div>

      <div>
        <Details
          data={data}
          name={"oni hasan"}
          profile={profileImage}
          subTitle={"music specialist"}
        />
      </div>

      <div style={{ marginBottom: "40px", textAlign: "end" }}>
        <button className={style.button}>Back</button>
      </div>
    </>
  );
};

export default RoundVideoResult;
